import { render, staticRenderFns } from "./SitesIcon.vue?vue&type=template&id=dd2c5f06&"
import script from "./SitesIcon.vue?vue&type=script&lang=js&"
export * from "./SitesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports